import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import IndividualProgressIndicator from 'feature/loading-management/create-new-common/IndividualProgressIndicator';
import { useAddLocationToDriverMutation } from '../driverStatusEndpoints';

const locationProgressStyles = {
  alignItems: 'center',
  borderBottom: `soflid 1px`,
  borderBottomColor: 'graphic.light',
  display: 'grid',
  gridAutoColumns: 'min-content 262px min-content',
  gridAutoFlow: 'column',
  gridGap: 2,
  p: (2, 3),
};
const locationTitleStyles = {
  maxWidth: '260px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const SubmittedLocation = ({ fullName, updateHandler, locationId, driverId }) => {
  const [submitLocation, { isError, isSuccess }] = useAddLocationToDriverMutation();

  useEffect(() => {
    submitLocation({ driverId, locationId })
      .unwrap()
      .then(() => {
        updateHandler();
      })
      .catch(err => {
        updateHandler({ err, error: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box sx={locationProgressStyles}>
        <CheckBoxRoundedIcon sx={{ color: 'graphic.main', mr: 1 }} />
        <Typography color="textPrimary" sx={locationTitleStyles} variant="body1">
          {fullName}
        </Typography>
        <IndividualProgressIndicator
          error={isError ? 'error' : ''}
          isSuccessful={isSuccess ?? false}
        />
      </Box>
      <Divider />
    </>
  );
};

SubmittedLocation.propTypes = {
  driverId: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  locationId: PropTypes.number.isRequired,
  updateHandler: PropTypes.func.isRequired,
};

export default SubmittedLocation;
